import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "params" }
const _hoisted_2 = { class: "params__wrapper" }

import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {AccusedPersonsAnalyticProps} from "@/types/analytics";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccusedInCourt',
  props: {
    activeType: {},
    selectedRegion: {},
    selectedDistrict: {},
    analyticData: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StatBlock, {
        title: "число обвиняемых по направленным в суд делам",
        value: __props.analyticData.totalData?.accused_in_court_cases?.value,
        percent: __props.analyticData.totalData?.accused_in_court_cases?.percent_to_previous,
        "is-appg": false,
        "is-main": true
      }, null, 8, ["value", "percent"]),
      _createVNode(StatBlock, {
        title: "число н/л обвиняемых по делам (ч.1 ст. 427 УПК РФ)",
        value: __props.analyticData.totalData?.juvenile_accused?.value,
        percent: __props.analyticData.totalData?.juvenile_accused?.percent_to_previous,
        "is-appg": false
      }, null, 8, ["value", "percent"]),
      _createVNode(StatBlock, {
        title: "число лиц по уголовным делам с ходатайством о назначении судебного штрафа (ст.446.2 УПК РФ)",
        value: __props.analyticData.totalData?.persons_with_court_fine?.value,
        percent: __props.analyticData.totalData?.persons_with_court_fine?.percent_to_previous,
        "is-appg": false
      }, null, 8, ["value", "percent"]),
      _createVNode(StatBlock, {
        title: "число лиц, в отношении которых прекращены дела",
        value: __props.analyticData.totalData?.persons_with_terminated_cases?.value,
        percent: __props.analyticData.totalData?.persons_with_terminated_cases?.percent_to_previous,
        "is-appg": false
      }, null, 8, ["value", "percent"])
    ]),
    _createVNode(DynamicByMonth, {
      "active-type": __props.activeType,
      "selected-region": __props.selectedRegion,
      "selected-district": __props.selectedDistrict,
      dynamic: __props.analyticData.monthlyDynamic
    }, null, 8, ["active-type", "selected-region", "selected-district", "dynamic"]),
    (__props.activeType !== 'region')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(RegionTop, {
            "sort-order": "desc",
            "active-type": __props.activeType,
            "selected-district": __props.selectedDistrict,
            "region-list": __props.analyticData.topDescending
          }, null, 8, ["active-type", "selected-district", "region-list"]),
          _createVNode(RegionTop, {
            "sort-order": "asc",
            "active-type": __props.activeType,
            "selected-district": __props.selectedDistrict,
            "region-list": __props.analyticData.topAscending
          }, null, 8, ["active-type", "selected-district", "region-list"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})